<template>
  <el-aside width="200px" class="admin-aside">
    <el-menu :default-active="$route.path" class="el-menu-vertical" router>
      <el-menu-item index="/admin">
        <i class="el-icon-menu"></i>
        <span>门店欢迎语配置</span>
      </el-menu-item>
      <el-menu-item index="/admin/videos">
        <i class="el-icon-video-camera"></i>
        <span>门店视频管理</span>
      </el-menu-item>
      <el-menu-item index="/admin/rotation">
        <i class="el-icon-setting"></i>
        <span>轮播时长配置</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'AdminSidebar'
};
</script>

<style scoped>
.admin-aside {
  background-color: #f5f7fa;
  flex-shrink: 0;
}
</style>

